import { licenceKey } from "./../../../license/license";
/* tslint:disable */
declare var Object: any;
import { Injectable } from "@angular/core";
import { Token, User } from "../models/base.models";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Config } from "../config/api.config";
import { environment } from "./../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserService {
  public token: Token = new Token();
  protected prefix: string = "$EPPM$";

  public isTokenRefreshed: boolean = false;

  constructor(private router: Router, private http: HttpClient) {
    this.token.user = this.load("user");
    this.token.userId = this.load("userId");
    this.token.expires = this.load("expires");
    this.token.token = this.load("token");
    this.token.claims = this.load("claims");
    this.token.roles = this.load("roles");
    this.token.refreshToken = this.load("refreshToken");
  }

  /**
   * This method will update the user information and persist it
   **/
  public setUser(user: any) {
    this.token.user = JSON.stringify(user);
    this.save();
  }

  /**
   * This method will update the user claims and persist it
   **/
  public setClaims(claims?: any) {
    this.token.claims = JSON.stringify(claims);
    this.save();
  }

  /**
   * @method setToken
   * @param {Token} token Token or casted AccessToken instance
   * @return {void}
   * @description
   * This method will set a flag in order to remember the current credentials
   **/
  public setToken(token: Token): void {
    this.token = Object.assign({}, this.token, token);
    this.save();
  }

  public setRefreshToken(refreshToken: string): void {
    this.token.refreshToken = Object.assign(
      {},
      this.token.refreshToken,
      refreshToken
    );
    this.save();
  }

  /**
   * @method getToken
   * @return {void}
   * @description
   * This method will set a flag in order to remember the current credentials.
   **/
  public getToken(): Token {
    return <Token>this.token;
  }

  /**
   * @method getAccessTokenId
   * @return {string}
   * @description
   * This method will return the actual token string, not the object instance.
   **/
  public getAccessTokenId(): string {
    return this.token.token;
  }

  public isAuthenticated(): string {
    return this.token.token && this.token.userId;
  }

  /**
   * @method getCurrentUserId
   * @return {any}
   * @description
   * This method will return the current user id, it can be number or string.
   **/

  public getCurrentUserId(): any {
    return this.token.userId;
  }

  /**
   * @method getCurrentUserData
   * @return {any}
   * @description
   * This method will return the current user instance.
   **/
  public getCurrentUserData(): User {
    return typeof this.token.user === "string"
      ? JSON.parse(this.token.user)
      : this.token.user;
  }

  public getCurrentUserClaims(): any {
    return typeof this.token.claims === "string"
      ? JSON.parse(this.token.claims)
      : this.token.claims;
  }

  public isUserAllowedTo(claim: string): any {
    let userClaims = this.getCurrentUserClaims() || [];

    return userClaims.indexOf(claim) >= 0;
  }

  /**
   * @method save
   * @return {boolean} Whether or not the information was saved
   * @description
   * This method will save in either local storage or cookies the current credentials.
   **/
  public save(): boolean {
    let expires = new Date(this.token.expires);
    this.persist("token", this.token.token, expires);
    this.persist("user", this.token.user, expires);
    this.persist("userId", this.token.userId, expires);
    this.persist("expires", this.token.expires, expires);
    this.persist("claims", this.token.claims, expires);
    this.persist("roles", this.token.roles, expires);
    this.persist("position", this.token.position, expires);
    this.persist("refreshToken", this.token.refreshToken, expires);

    return true;
  }

  /**
   * @method load
   * @param {string} prop Property name
   * @return {any} Any information persisted in storage
   * @description
   * This method will load either from local storage or cookies the provided property.
   **/
  public load(prop: string) {
    return localStorage.getItem(`${this.prefix}${prop}`);
  }

  /**
   * @method clear
   * @return {void}
   * @description
   * This method will clear cookies or the local storage.
   **/
  public clear(): void {
    Object.keys(this.token).forEach((prop: string) =>
      localStorage.removeItem(`${this.prefix}${prop}`)
    );
    this.token = new Token();
    this.token.user = null;
  }

  /**
   * @method persist
   * @return {void}
   * @description
   * This method saves values to storage
   **/
  protected persist(prop: string, value: any, expires?: Date): void {
    try {
      if (value)
        localStorage.setItem(
          `${this.prefix}${prop}`,
          typeof value === "object" ? JSON.stringify(value) : value
        );
    } catch (err) {}
  }

  public getRefreshToken() {
    let body = {
      accessToken: this.token.token,
      refreshToken: this.token.refreshToken,
    };
    const headers = new HttpHeaders({
      "License-Key": licenceKey.valid,
    });
    return this.http.post(
      environment.serverUrl + Config.Identity.RefreshToken,
      body,
      { headers }
    );
    // .subscribe(
    //   (res: any)=> {
    //     if(res) {
    //       this.token.token = res.accessToken;
    //       location.reload();
    //      // this.isTokenRefreshed = true;
    //     //  // if(this.isTokenRefreshed)
    //     //  console.log(this)
    //     //  if(this instanceof Function)
    //     //     console.log("Hiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii")
    //     }
    //   },
    //   (err: any) => {
    //     if(err.status == 400) {
    //       this.clear();
    //       this.router.navigate(['/login']);
    //     }
    // });
  }

  generateSsoToken() {
    const headers = new HttpHeaders({
      "License-Key": licenceKey.valid,
      Authorization: "Bearer " + this.token.token,
    });
    return this.http.put(
      environment.serverUrl + Config.Identity.GenerateSsoToken,
      {},
      { headers }
    );
  }
}
